import type { Block, Text } from '@ksa/model'
import { SiteText, hasText } from '../context.tsx'
import { Icon } from '../icons.tsx'

type Item = { icon: string; title: Text; body: Text }
type Props = { heading: Text; items: Item[] }

export function FeaturesBlock({ block }: { block: Block }) {
  const p = block.props as unknown as Props
  const items = p.items ?? []
  const cards = block.variant === 'cards'
  const numbered = block.variant === 'numbered'

  return (
    <section className="s-section">
      <div className="s-wrap s-stack-lg">
        {hasText(p.heading) && (
          <h2 className="s-h2 s-center">
            <SiteText value={p.heading} />
          </h2>
        )}
        {/* A `<ul>` rather than divs: a screen reader announces "list, 3 items" before reading them,
            which is the difference between a scannable row and three unrelated paragraphs. */}
        <ul className="s-grid" style={{ listStyle: 'none', margin: 0, padding: 0 }}>
          {items.map((item, i) => (
            <li key={i} className={cards ? 's-card' : ''}>
              {numbered ? (
                // The number is `aria-hidden` because the list already announces its position, and
                // "1. 1. Book a table" is what happens when both speak.
                <div className="s-feature__number" aria-hidden="true">
                  {i + 1}
                </div>
              ) : (
                item.icon !== 'none' && <Icon name={item.icon} className="s-feature__icon" />
              )}
              <h3 className="s-h3">
                <SiteText value={item.title} />
              </h3>
              {hasText(item.body) && (
                <p className="s-body" style={{ marginBlockStart: '0.5rem', color: 'var(--muted)' }}>
                  <SiteText value={item.body} />
                </p>
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
